var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page forbit-cancel-tree" },
    [
      _c(
        "Modal",
        {
          staticClass: "page-modal",
          attrs: {
            width: "45%",
            "mask-closable": false,
            "footer-hide": true,
            title: _vm.$t("deviceSip.importAddr"),
            "class-name": "vertical-center-modal",
          },
          model: {
            value: _vm.importModal,
            callback: function ($$v) {
              _vm.importModal = $$v
            },
            expression: "importModal",
          },
        },
        [
          _c("div", { staticClass: "main-box margin-bottom-20" }, [
            _c("div", { staticClass: "left-box" }, [
              _c("form", { attrs: { id: "uploadExcel" } }, [
                _c("div", { staticClass: "upload-box" }, [
                  _c(
                    "a",
                    { staticClass: "file", attrs: { href: "javascript:;" } },
                    [
                      _c("Icon", {
                        staticClass: "upload-icon",
                        attrs: { type: "md-cloud-upload" },
                      }),
                      _c("input", {
                        ref: "xmlFile",
                        attrs: {
                          type: "file",
                          name: "addrBook",
                          accept: "text/xml, application/xml",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.showPic($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("span", [_vm._v(_vm._s(_vm.uploadTip))]),
              _c("div", { staticClass: "secret-box" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("updateNewSip.secret")))]),
                _c(
                  "div",
                  { staticClass: "secret-input" },
                  [
                    _c("Input", {
                      attrs: {
                        type: "text",
                        size: "large",
                        placeholder: _vm.$t("updateNewSip.secretTip"),
                        maxlength: "32",
                      },
                      model: {
                        value: _vm.secret,
                        callback: function ($$v) {
                          _vm.secret = $$v
                        },
                        expression: "secret",
                      },
                    }),
                    _c(
                      "h4",
                      [
                        _c("Icon", {
                          attrs: {
                            type: "md-information-circle",
                            ssize: "30",
                            color: "#fc7790",
                          },
                        }),
                        _vm._v(
                          " " + _vm._s(_vm.$t("updateNewSip.noSecretTip")) + " "
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "detailBackBtn" },
                [
                  _c(
                    "Button",
                    {
                      attrs: { type: "default", size: "large" },
                      on: { click: _vm.backBtn },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                  ),
                  _c(
                    "Button",
                    {
                      attrs: { type: "primary", size: "large" },
                      on: { click: _vm.uploadEx },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.submit")))]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _c("div", { staticClass: "content_win" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }